/**
 * German EUR price formatting. Cents in, "5,99 €" out (Intl inserts a
 * non-breaking space, U+00A0, before the currency sign — callers/tests that
 * need a plain space should normalise it).
 */
export function formatPrice(cents: number, opts?: { perMonth?: boolean }): string {
  const euros = cents / 100;
  const formatted = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(euros);

  return opts?.perMonth ? `${formatted}/Monat` : formatted;
}
